import { useCallback } from "react";
import {
  getCacheItem,
  updateCacheItem,
  removeCacheItem,
  clearCache,
} from "../utils/cache";

export function useCache() {
  const get = useCallback((key) => getCacheItem(key), []);
  const set = useCallback((key, value, options) => updateCacheItem(key, value, options), []);
  const remove = useCallback((key) => removeCacheItem(key), []);
  const clear = useCallback(() => clearCache(), []);

  return { get, set, remove, clear };
}
